import styled from 'styled-components';

export const ContactContainer = styled.div``;

export const Content = styled.section`
  padding: 80px 0;
  
  h2 {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 2.5rem;
    margin-bottom: 2rem;
    text-align: center;
  }
  
  p {
    font-size: 1.1rem;
    line-height: 1.8;
    margin-bottom: 1.5rem;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const ContactSection = styled.section`
  display: grid;
  /* grid-template-columns: 1fr 2fr; */
  gap: 4rem;
  padding: 10px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

export const ContactInfo = styled.div`
  h2 {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  > p {
    color: ${({ theme }) => theme.colors.text};
    margin-bottom: 2rem;
  }

  .info-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 2rem;

    svg {
      color: ${({ theme }) => theme.colors.primary};
      font-size: 1.5rem;
      margin-right: 1rem;
      margin-top: 0.5rem;
    }

    h3 {
      color: ${({ theme }) => theme.colors.text};
      margin-bottom: 0.5rem;
    }

    p {
      color: ${({ theme }) => theme.colors.lightText};
      line-height: 1.6;
    }
  }
`;


export const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin: 2rem 0;

    th, td {
        padding: 1rem;
        text-align: left;
        border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
    }

    th {
        background-color: ${({ theme }) => theme.colors.primary};
        color: #fff;
        font-weight: 600;
    }

    tr:nth-child(even) {
        background-color: ${({ theme }) => theme.colors.lightGray};
    }

    tr:hover {
        background-color: ${({ theme }) => theme.colors.secondaryLight || '#f5f5f5'};
    }
`;

export const NewsContainer = styled.div``;

export const Hero = styled.section`
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url('/images/news-hero.jpg') center/cover no-repeat;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;

  h1 {
    font-size: 3rem;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.2rem;
  }
`;

export const NewsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 80px 0;
`;

export const NewsCard = styled.article`
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  .image {
    position: relative;
    height: 200px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .category {
      position: absolute;
      top: 1rem;
      right: 1rem;
      background: ${({ theme }) => theme.colors.primary};
      color: white;
      padding: 0.5rem 1rem;
      border-radius: 20px;
      font-size: 0.9rem;
    }
  }

  .content {
    padding: 1.5rem;

    .date {
      color: ${({ theme }) => theme.colors.lightText};
      font-size: 0.9rem;
    }

    h3 {
      margin: 1rem 0;
      color: ${({ theme }) => theme.colors.text};
      font-size: 1.3rem;
    }

    p {
      color: ${({ theme }) => theme.colors.lightText};
      margin-bottom: 1.5rem;
      line-height: 1.6;
    }
  }
`;

export const NewsletterSection = styled.section`
  background-color: ${({ theme }) => theme.colors.lightGray};
  padding: 80px 0;
  text-align: center;

  h2 {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }

  p {
    color: ${({ theme }) => theme.colors.text};
    margin-bottom: 2rem;
  }

  form {
    display: flex;
    gap: 1rem;
    max-width: 500px;
    margin: 0 auto;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      flex-direction: column;
    }

    input {
      flex: 1;
      padding: 0.8rem 1rem;
      border: 1px solid #ddd;
      border-radius: 5px;
      font-size: 1rem;

      &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`;

export const PageButton = styled.button`
  margin: 0 5px;
  padding: 0.5rem 0.75rem;
  border: none;
  border-radius: 4px;
  background-color: ${({ active }) => (active ? '#5c5655' : '#eee')};
  color: ${({ active }) => (active ? '#fff' : '#000')};
  cursor: pointer;
  
  &:hover {
    background-color: ${({ active }) => (active ? '#423e3e' : '#ddd')};
  }
`;

